export default "__VITE_PUBLIC_ASSET__a1b5bbcf__"